// IMPORTS
import _ from 'lodash'
import axios from 'axios'
import mobiscroll from '@mobiscroll/javascript'
import Db from '../../db'
import swal from 'sweetalert'
import {notify} from '../../utils'

// DEFINITIONS
const   LoginAPI = 'account/trylogin',
        SignUpAPI = 'account/register',
        PinConfirmAPI = 'account/pinconfirm'

const emptyUser = {
	id: null,
	imagenes_id_avatar: null,
	nombre: null,
	apellidos: null,
	email: null,
	telefono: null,
	telefono_is_blackfon: null,
	modificado: null,

	// DOMICILIO
	calle: null,
	numero: null,
	colonia: null,
	codigo_postal: null,
	estado: null,
	ciudad: null,
	persona: null,

	// FACTURACIÓN
	facturacion: null,
	rfc: null,
	razonsocial: null,
};

const state = {
	token: null,
	user: _.clone(emptyUser)
}

const getters = {
	isLogged: (state) => {
		return (!!state.token)
	},
	getUser: (state) => {
		return state.user
	},
	accountGetToken: (state) => {
		return state.token
	}
}

const mutations = {
	authCloseSession: async (state) => {
		await Db.configs.where('key').equalsIgnoreCase('auth').delete()
		state.token = null
		state.user = _.clone(emptyUser)
	},
	authSetAccount: async (state, payload) => {
		state.token = payload.token
		state.user = payload
		await Db.configs.where('key').equalsIgnoreCase('auth').delete()
		await Db.configs.add({ key: 'auth', value: JSON.stringify(state) })
	}
}

const actions = {
	authTryLogin: async ({commit}, payload) => {
		try {
			// RESPONSE
			let response = await axios.post(LoginAPI, payload)

			
			// RESPONSE STATUS
			if(response.status)
				commit('authSetAccount', response.data)
			
			// ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
			else if (response.msg) 
				notify(response.msg, response.class || 'info')
			
			return response

		} catch(e){
			console.error(e)
			mobiscroll.snackbar({
				display: 'top',
				theme: 'ios',
				message: 'Ocurrió un error obteniendo la respuesta: ' + e,
				color: 'warning',
				duration: 7000
			})
		}
	},
	authAsk4LogOut: async ({commit}) => {
		try {
			let swalResponse = await swal({
				icon: 'info',
				title: '¿Estás seguro que deseas finalizar sesión?',
				buttons: {
					cancel: 'Cancelar',
					danger: 'Cerrar sesión'
				}
			});
			if(swalResponse){
				commit('authCloseSession')
				commit('skyaccountClear')
				swal({
					icon: 'success',
					title: '¡Hasta pronto!',
					text: 'Sesión finalizada',
				})
				return true
			}
		} catch(e){
			console.error(e)
			mobiscroll.snackbar({
				display: 'top',
				theme: 'ios',
				message: 'Ocurrió un error obteniendo la respuesta: ' + e,
				color: 'warning',
				duration: 7000
			})
		}
	},
	authLoadUp: async ({commit}) => {
		try {
			let response = await Db.configs.where('key').equalsIgnoreCase('auth').first();

			if(!!response){
				let state = JSON.parse(response.value);
				commit('authSetAccount', state.user)
			}
		} catch(e){
			console.error(e)
			mobiscroll.snackbar({
				display: 'top',
				theme: 'ios',
				message: 'Ocurrió un error obteniendo la respuesta: ' + e,
				color: 'warning',
				duration: 7000
			})
		}
	},
	authConfirmPIN: async ({commit}, payload) => {
		try {
			let response = await axios.post(PinConfirmAPI, payload, { withCredentials: false })
			if(response.status)
				commit('authSetAccount', response.data)
			else 
				throw response.msg
			return response;
		} catch (e) {
			console.error(e)
			notify(e)
			return {status: false}
		}
	},
	authSignUp: async ({}, payload) => {
		try {
			let response = await axios.post(SignUpAPI, payload, { withCredentials: false })
			
			// ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
			if (response.msg) {
				mobiscroll.snackbar({
					display: 'top',
					theme: 'ios',
					message: response.msg,
					color: response.class,
					duration: 7000
				})
			}
			
			// RESPONSE STATUS
			return response;
		} catch(e) {
			console.error(e)
			mobiscroll.snackbar({
				display: 'top',
				theme: 'ios',
				message: 'Ocurrió un error obteniendo la respuesta: ' + e,
				color: 'warning',
				duration: 7000
			})
			return false;
		}
	}
}

// EXPORTS
export default {
	state,
	getters,
	mutations,
	actions
};